export const STUNDEN_MAX = 24;
export const MARGIN = { top: 60, bottom: 60, left: 40, right: 40 };
export const TEXT_PADDING = 12;
export const MITARBEITER_THRESHOLD = 2;
